module.exports = function (Component) {
  Component.options.__i18n = Component.options.__i18n || []
  Component.options.__i18n.push('{"en":{"pageTitle":"Baianat help center","pageDesc":"Here you can find common questions and all answers on the specific topics you need to know."},"ar":{"pageTitle":"مركز المساعدة","pageDesc":"هنا يمكنك العثور على الاسئلة الشائعة وجميع الاجابات على المواضيع التي تريد معرفتها."}}')
  delete Component.options._Ctor
}
